// Browser-side membership for the user-aware Partytown fbevents-offload experiment
// (all__fb-pixel_partytown-offload__web). The treatment-bucket boolean is resolved per user at
// SSR and seeded into this module from `_app` (`setPartytownEnabledInMemory`), mirroring the
// DS-ramp `setDSRampUserInMemory` pattern. Kept off the user-agnostic feature-gate memory because
// the offload is now a per-user experiment, not a global gate.

// Treatment membership for this request. Seeded once from pageProps on the client; SSR reads the
// prop directly in _document, so this stays `false` on the server.
let partytownEnabledForRender = false

export function setPartytownEnabledInMemory(enabled: boolean | undefined | null): void {
  partytownEnabledForRender = Boolean(enabled)
}

/**
 * Browser-only read of the Partytown experiment treatment membership. Used by client telemetry
 * (FbPixel init, SPA route-change PageView) to decide whether fbevents.js runs in the Partytown
 * worker for this request.
 */
export function isPartytownEnabledInBrowser(): boolean {
  if (typeof window === 'undefined') {
    return false
  }

  return partytownEnabledForRender
}
